import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NaacSubHeadingListComponent } from './naac-sub-heading-list/naac-sub-heading-list.component';
import { NaacSubHeadingCreateComponent } from './naac-sub-heading-create/naac-sub-heading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: NaacSubHeadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: NaacSubHeadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'naac-sub-heading-create/:id',
        component: NaacSubHeadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NaacSubHeadingRoutingModule { }
